export const DEFAULT_SEARCH_SIMILAR_SPACES_LINK =
  "/s/san-francisco/?space_use=Off-Site";

export const buildRecommendedListingsSearchLink = ({
  listingCity,
  listingState,
  listingCountry,
  neighborhood,
  useType,
}: {
  listingCity: string;
  listingState?: string;
  listingCountry: string;
  neighborhood: string;
  useType: string;
}): string => {
  const location = `${neighborhood ? neighborhood.split(" ").join("-") + "--" : ""}${listingCity.split(" ").join("-")}--${listingState ? listingState.split(" ").join("-") + "--" : ""}${listingCountry.split(" ").join("-")}`;
  return listingCity && useType
    ? `/s/?space_use=${useType}&location=${location} `
    : DEFAULT_SEARCH_SIMILAR_SPACES_LINK;
};

export const buildSimilarSpacesUrl = ({
  city,
  state,
  useType,
}: {
  city?: string;
  state?: string;
  useType?: string;
}): string => {
  const sanitizeString = (str: string) => str.replaceAll(/[\s,.'"]/g, "-");
  const sanitizedCity = city ? sanitizeString(city) : "";
  const sanitizedState = state ? `--${sanitizeString(state)} ` : "";
  const redirLocation = sanitizedCity + sanitizedState;

  if (sanitizedCity && useType) {
    return `/s/?space_use=${useType}&location=${redirLocation.toLowerCase()}`;
  }
  return DEFAULT_SEARCH_SIMILAR_SPACES_LINK;
};
